import React from 'react';
import InspectorCard from './inspector_card';

export default function Facilities(props) {
	return (
		<InspectorCard header="Facilities" {...props}>
      <div className="abl-inspector-group abl-facilities-card">
        <div className="abl-label-group">
          <label>Room #</label>
          <div className="abl-label-content">
            119
          </div>
        </div>
        <div className="abl-label-group">
          <label>Capacity</label>
          <div className="abl-label-content">
            30
          </div>
        </div>
        <div className="abl-label-group">
          <label>Type</label>
          <div className="abl-label-content">
            Lab, Cafeteria, Small Group, etc
          </div>
        </div>
        <div className="abl-label-group">
          <label>Used by</label>
          <div className="abl-label-content">
            <ul>
              <li>A. Filsinger</li>
              <li>C. Walsh</li>
            </ul>
          </div>
        </div>
         <div className="abl-label-group">
          <label>Materials</label>
          <div className="abl-label-content">
            <ul>
              <li>Projector</li>
              <li>Lab tables</li>
            </ul>
          </div>
        </div>
      </div>
    </InspectorCard>
	);
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/facilities.js
 **/